import RouteContainer from 'containers/RouteContainer';
import Component from './components/Documents';

export default RouteContainer(DOCUMENTS_PATH, Component);
